import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// Category - Get All (Read)
export const GetAllHistory = createAsyncThunk(
    "admin/color-predicition/all-history",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/history?name=${filter?.name || ""}&play_time_id=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetAllwinningHistory = createAsyncThunk(
    "admin/color-predicition/all-winning-history",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/winning-history?name=${filter?.name || ""}&play_time_id=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetSummaryData = createAsyncThunk(
    "admin/color-predicition/summary-data",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/summary_data?name=${filter?.name || ""}&play_time_id=${filter?.status || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetBetSummaryData = createAsyncThunk(
    "admin/color-predicition/bet-summary-data",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/bets?play_time_id=${filter?.play_time_id || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const GetRecentPeriodHistory = createAsyncThunk(
    "admin/color-predicition/GetRecentPeriodHistory",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Games.Color_Prediction}/recent-period?play_time_id=${filter?.play_time_id || ""}&uid=${filter?.uid || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&email=${filter?.email || ""
                }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
                }&end_date=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const PostCustomResult = createAsyncThunk(
    "admin/color-predicition/PostCustomResult",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(
                `${APIS.Games.Color_Prediction}/custom-result`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const Slice = createSlice({
    name: "color_redictions",
    initialState: {
        data: [],
        summary_data: {},
        bet_summary_data: {},
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetCategory, AddCategory, UpdateCategory, DeleteCategory
            .addCase(GetAllHistory.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllHistory.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAllHistory.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetAllwinningHistory.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })

            .addCase(GetAllwinningHistory.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAllwinningHistory.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetSummaryData.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSummaryData.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.summary_data = action.payload?.data || [];

            })
            .addCase(GetSummaryData.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetBetSummaryData.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetBetSummaryData.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.bet_summary_data = action.payload?.data || [];

            })
            .addCase(GetBetSummaryData.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })



            .addCase(GetRecentPeriodHistory.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })

            .addCase(GetRecentPeriodHistory.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetRecentPeriodHistory.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

export const { } = Slice.actions;

export default Slice.reducer;
